// epics.js
import { combineEpics, ofType } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { from, of } from "rxjs";
import {
  loginRequest,
  loginSuccess,
  loginFailure,
  signupRequest,
  signupSuccess,
  signupFailure,
  googleLoginRequest,
  googleLoginFailure,
  userRolesRequest,
  userRolesSuccess,
  userRolesFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  resetPasswordRequest,
  resetPasswordFailure,
  resetPasswordSuccess,
  userLocationRequest,
  userLocationSuccess,
  userLocationFailure,
  currencyRateListRequest,
  currencyRateListSuccess,
  currencyRateListFailure
} from "./auth";
import { observablePOST, observableGET } from "@/api/apiClient";
import { hideModal } from "@/store/slices/modalSlice";
import { notification } from "antd";
import i18next from "i18next";

// Login Epic
const fetchDataLoginEpic = (action$) =>
  action$.pipe(
    ofType(loginRequest.type),
    mergeMap((action) => {
      const { email, password } = action.payload;
      return observablePOST(`/auth/login`, {
        body: { email, password }
      }).pipe(
        // TODO: handle success
        mergeMap((response) => {
          notification.success({
            message: i18next.t("login.loginSuccessTitle"),
            description: i18next.t("login.loginSuccessMessage"),
            placement: "topRight"
          });

          return of(loginSuccess(response.data), hideModal());
        }),
        catchError((error) => of(loginFailure(error)))
      );
    })
  );

// Signup Epic
const fetchDataSignupEpic = (action$) => {
  return action$.pipe(
    ofType(signupRequest.type),
    mergeMap((action) => {
      const { email, password } = action.payload.userDto;

      return observablePOST(`/users`, {
        body: action.payload
      }).pipe(
        mergeMap((response) => {
          return of(
            signupSuccess(response.data),
            hideModal(),
            loginRequest({
              email: email,
              password: password
            })
          );
        }),
        catchError((error) => of(signupFailure(error)))
      );
    })
  );
};

// Google Login Epic
const fetchDataGoogleLoginEpic = (action$) => {
  return action$.pipe(
    ofType(googleLoginRequest.type),
    mergeMap((action) => {
      const { credential } = action.payload;
      // TODO Redirect to login
      return observablePOST(`/auth/google-login/${credential}`).pipe(
        mergeMap((response) => of(loginSuccess(response.data), hideModal())),
        catchError((error) => of(googleLoginFailure(error)))
      );
    })
  );
};

// users roles
const fetchDataUserRolesEpic = (action$) => {
  return action$.pipe(
    ofType(userRolesRequest.type),
    mergeMap(() => {
      return observableGET(`/roles`).pipe(
        mergeMap((response) => of(userRolesSuccess(response.data))), //
        catchError((error) => of(userRolesFailure(error)))
      );
    })
  );
};

// user forgot password
const fetchDataForgotPasswordEpic = (action$) => {
  return action$.pipe(
    ofType(forgotPasswordRequest.type),
    mergeMap((action) => {
      const { email } = action.payload;
      return observablePOST(`/users/forget-password`, {
        body: { email }
      }).pipe(
        mergeMap((response) =>
          of(forgotPasswordSuccess(response.data), hideModal())
        ),
        catchError((error) => of(forgotPasswordFailure(error)))
      );
    })
  );
};
// user reset password
const fetchDataResetPasswordEpic = (action$) => {
  return action$.pipe(
    ofType(resetPasswordRequest.type),
    mergeMap((action) => {
      const { token, password } = action.payload;
      return observablePOST(`/users/reset-password/${token}`, {
        body: { password }
      }).pipe(
        mergeMap((response) =>
          of(resetPasswordSuccess(response.data), hideModal())
        ),
        catchError((error) => of(resetPasswordFailure(error)))
      );
    })
  );
};

const userLocationEpic = (action$) =>
  action$.pipe(
    ofType(userLocationRequest.type),
    mergeMap(() =>
      from(fetch("https://get.geojs.io/v1/ip/geo.json")).pipe(
        mergeMap((response) =>
          response.json().then((data) => {
            return userLocationSuccess(data);
          })
        ),
        catchError((error) => of(userLocationFailure(error)))
      )
    )
  );

const fetchCurrencyRateEpic = (action$) => {
  return action$.pipe(
    ofType(currencyRateListRequest.type),
    mergeMap(() => {
      return observableGET(`/currency`).pipe(
        mergeMap((response) => of(currencyRateListSuccess(response.data))), //
        catchError((error) => of(currencyRateListFailure(error)))
      );
    })
  );
};

const authEpic = combineEpics(
  fetchDataLoginEpic,
  fetchDataSignupEpic,
  fetchDataGoogleLoginEpic,
  fetchDataUserRolesEpic,
  fetchDataForgotPasswordEpic,
  fetchDataResetPasswordEpic,
  userLocationEpic,
  fetchCurrencyRateEpic
);

export default authEpic;
